import script from "./SidebarControls.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarControls.vue?vue&type=script&setup=true&lang=js"

import "./SidebarControls.vue?vue&type=style&index=0&id=2c2fbc66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c2fbc66"]])

export default __exports__